module.exports = __webpack_public_path__ + "img/menu-retour.e9195dc5.svg";